<div class="rating-review-wrap">
    <form class="example-form" [formGroup] = "createForm" (ngSubmit)="saveReview(createForm)">
  <div class="rating-review-ttl">
    <h4>Rating Review</h4>
    <button class="cls-dlg-cls" mat-dialog-close="false" mat-button (click)="onclose()"><i class="material-icons">close</i></button>
  </div> 
  <mat-card-content>
      <mat-dialog-content> 
   <div>    
			<bar-rating [(rate)]="rateValue" [max]="5" (rateChange)="fnratingvalue($event)"></bar-rating>	
    </div>
    <div>
        <mat-form-field class="full-input">
            <textarea matInput placeholder="Write a Review" formControlName="ReviewDescription" maxlength="200"></textarea>            
          </mat-form-field>
    </div>
    <!-- <ul > -->
        <span *ngIf="reviewList.length== 0" class="text-center">No review found</span>
        <ul class="list-rate-rvw">
    <li class="list-group" *ngFor="let r of reviewList; let i = index">   
        <h6>{{r.UserName}}</h6>
        <p>{{r.ReviewDescription}}</p>
        <i>{{r.CreatedDate}}</i>        
      </li>
    </ul>
    <!-- </ul>     -->
  </mat-dialog-content>
  </mat-card-content>
  <mat-dialog-actions>
    <button mat-raised-button >Submit</button>
  </mat-dialog-actions>
  </form>
</div>